<template>
<div class="dashboard-right-status">
	<div class="dashboard-list-top" style="position:relative;">
        <!-- <b-progress :value="value" :max="max" :label="`${((value / max) * 100).toFixed(2)}%`" show-progress animated></b-progress> -->
<!--        <b-progress :max="progressBarMaxValue"   v-if="totalCount > listCountOfPage"><b-progress-bar :value="progressBarValue"  variant="success"></b-progress-bar></b-progress> -->

		<div class="countdown-bar__wrapper"><div id="countdownBar" v-if="showCountdownBar" :key="'countdownbar-'+countdownKey" class="countdown-bar animate"></div></div>
        <!-- <b-progress :max="max" show-value  v-if="totalCount > 6"><b-progress-bar :value="value"  :label="`${value}%`"  variant="success"></b-progress-bar></b-progress> -->
        <div class="container-fluid" :style="{  zIndex: 100 }" >
            <div class="row">
                <div class="col-sm-7 col-md-8 col-8 left-side  header-controls"  ><!---->
                        <div class="dashboard-list-header" style="z-index: 700;" >
                                        <span class="listTitle"><h2>Media Calls <span class="newMediaCallCount" v-if="newMediaCallCount > 0">+{{newMediaCallCount}}</span></h2></span>
                                        <!-- <span class="lastUpdate">Last Updated {{lastUpdated  | moment("MMM D,YYYY HH:mm a")}}</span>
                                        <span class="offLineMessage">{{isOnLine | offlineMessage}}</span> -->
                         </div>
                  </div>
              <div class="col-sm-5 col-md-4 col-4 text-right right-side  header-controls">
                        <div class="logo-user"><div class="header__notification">
                            <div class="float-right"><img src="/images/logo.svg?e0b2ae29f7aea7fcaf0153e097df8ceb" class="logo"></div>
                        </div></div>

              </div>
        </div>
        </div>
    </div>
    <div>
  </div>
<div class="dashboard-list-listing-wrapper">

<div id="dashboard-listing" :class="dashboardListingClass()" v-if="isLoaded">

	<div id="global-spinner" v-if="loading" style="left:66.5%; border:none; background:transparent;">
	  <b-spinner label="Loading"></b-spinner>
	</div>

    <div  style="z-index: 1;" id="allList01" class="dashboard-right-item clearfix" v-if="totalCount > 0">
<!-- component start -->
<!-- :autoplay= 10000  -->
    <!-- <MediaCallsList :allDeliverables="allDeliverables" :totalPage="totalPage"  /> -->
      <swiper :style="swiperCSS" id="swiper__media-calls" @slide-change-start="slideChangeStart" ref="swiper"  :speed=1000  direction="vertical" :key="'swiper'+swiperKey">
      <!-- <div v-for="n in totalPage" class="random-bg" :key="n"> {{n}}/{{totalPage}} -->
          <div v-for="n in totalPage" :key="n" :id="'deList'+n" class="swiper-row">
               <!-- totalPage=>/{{totalPage}}, n=>/{{n}} -->
                  <masonry
                  :cols="{default: 2, 1500: 1, 700: 1}"
                  :gutter="5"
                 >
                 <!-- 0,1,2,3,4,5,6,7,8,9 -->
                        <div  style="z-index: -1;"  :style="{  zIndex: 0 }" class="dashboard-list-block" v-for="(deliverable, index) in deliverablesArray.slice( (n-1)*PageCountOfSwiper ,n*PageCountOfSwiper)"
                             :key="'deliverable'+index" :id="'de'+index">
                                <div class="d-flex flex-row dbox-wrapper">
                                    <div class="dbox-left-side dleft-inner-wrap">
                                        <div class="top-row">
                                            <template>
                                                <div class="data-status-items hide-mobile" :style="{backgroundColor: `#4c9850`}"  v-if="deliverable.all_completed">
                                                    <span class="item_bg">COMPLETE</span>
                                                </div>
                                                <div class="data-status-items hide-mobile"  :style="{backgroundColor: getTitleBgColor(deliverable.tasks)}" v-else>
                                                    <span class="">IN PROGRESS</span>
                                                </div>
                                            </template>
                                            <div  class="data-items">
                                                <span>
                                                    {{timeTitle(deliverable.all_completed)}}: {{runningTime(deliverable)}}
                                                </span>
                                            </div>

                                        </div>

                                        <div class="row listing-row">
                                            <div class="col-md-11 titles breakpoint__fix" :style="infoColStyle(deliverable)">
                                            	<template v-if="deliverable.title != 'Media call'">
                                                <div :class="`dashboard-list-title`" v-if="deliverable.title.length < 45">
                                                    {{ deliverable.title }}
                                                </div>
                                                 <div :class="`dashboard-list-title`" v-else>
                                                    {{ deliverable.title }}
                                                </div>

                                                <div v-if="showDepartment(deliverable)">
                                                    <div  v-if="deliverable">
                                                        <div
                                                            class="department-title exclude-outside-click"
                                                            v-for="(department, index) in deliverable.departments"
                                                            :key="'deliverable-modal-department-'+department.id"
                                                        >
                                                            <span style="color: #2D3135" v-if="index > 0">&nbsp;&</span> {{ department.name }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="_.filter(deliverable.customFields, {field_key: 'questions'}).length==0">
                                                    <b-carousel
                                                        id= "index"
                                                        no-animation
                                                        :interval="8000"
                                                        controls
                                                        indicators

                                                        img-blank

                                                        @sliding-start="onSlideStart"
                                                        @sliding-end="onSlideEnd"
                                                        >
                                                        <!-- Slide with blank fluid image to maintain slide aspect ratio -->
                                                        <b-carousel-slide caption="" img-blank img-alt="Blank image">
                                                                <div  :ref="'totalSlide-'+n+'-'+index" :id="'totalSlide-'+n+'-'+index"> No questions have been entered. </div>
                                                        </b-carousel-slide>

                                                    </b-carousel>
                                                </div>
                                                <div v-for="(field,index2) in _.filter(deliverable.customFields, {field_key: 'questions'})" :key="index2">
                                                     <!-- v-model="currentSlide" -->

                                                     <div class="dashboard-list-content"  v-html="strippedContent(field.value,1)"></div>

                                                <b-carousel
                                                    id= "index"
                                                    no-animation
                                                    :interval="8000"
                                                    controls
                                                    indicators
                                                    v-if="false"
                                                    img-blank

                                                    @sliding-start="onSlideStart"
                                                    @sliding-end="onSlideEnd"
                                                    >
                                                    <!-- Slide with blank fluid image to maintain slide aspect ratio -->
                                                    <b-carousel-slide caption="" img-blank img-alt="Blank image" v-for="nn in setSlidingArray(field.value)" :key="nn">
                                                            <div  :ref="'totalSlide-'+n+'-'+index" :id="'totalSlide-'+n+'-'+index" :data-value="setSlidingArray(field.value)" v-html="strippedContent(field.value, nn)"></div>
                                                    </b-carousel-slide>

                                                    </b-carousel>

<!-- <p>===================</p>
<div>{{setSlidingArray(field.value)}}</div>
<div v-html="strippedContentOrigin(field.value)"></div> -->
                                                </div>
                                            <div v-if="false"  title="Delete" class="delete-bar" >
                                            </div>
                                        </template>
                                        <template v-else>
                                        	 <div :class="`dashboard-list-title`" >
                                        	    New media call being created.
                                        	</div>
                                        </template>
                                            </div>
                                            <div class="col-md-1 infos">
                                                <div class="d-flex flex-row">
                                                    <DeliverableStatusOverview :deliverable="deliverable"  v-if="!deliverable.all_completed" />
                                                </div>
                                            </div>
                                        </div>  <!-- -->
                                        <div class="bottom-row"  :style="bottomRowStyle(deliverable.tasks)">
                                        </div>
                                    </div>
                                </div>
                          </div>
                    </masonry>
            </div>
    </swiper>
 <!-- component end -->
    </div>
    <div  style="z-index: 1;" id="allList01" class="dashboard-right-item clearfix" v-else-if ="totalCount == 0">
          <div class="dashboard-not-entry">
                In progress media calls will be displayed here.
        </div>
    </div>
    <div  style="z-index: 1;" id="allList01" class="dashboard-right-item clearfix" v-else>
<!-- component start -->
    <!-- <MediaCallsList :allDeliverables="allDeliverables" :totalPage="totalPage"  /> -->

      <!-- <div v-for="n in totalPage" class="random-bg" :key="n"> {{n}}/{{totalPage}} -->

               <!-- totalPage=>/{{totalPage}}, n=>/{{n}} -->
                  <masonry
                  :cols="{default: 2, 1500: 1, 700: 1}"
                  :gutter="5"
                 >
                 <!-- 0,1,2,3,4,5,6,7,8,9 -->
                        <div  style="z-index: -1;"  :style="{  zIndex: 0 }" class="dashboard-list-block" v-for="(deliverable, index) in deliverablesArray"
                             :key="'deliverable'+index" :id="'de'+index">
                                <div class="d-flex flex-row dbox-wrapper">
                                    <div class="dbox-left-side dleft-inner-wrap">
                                        <div class="top-row">
                                            <template>
                                                <div class="data-status-items hide-mobile" :style="{backgroundColor: `#4c9850`}"  v-if="deliverable.all_completed">
                                                    <span class="item_bg">COMPLETE</span>
                                                </div>
                                                <div class="data-status-items hide-mobile" :style="{backgroundColor: getTitleBgColor(deliverable.tasks)}"  v-else>
                                                    <span class="">IN PROGRESS</span>
                                                </div>
                                            </template>
                                            <div  class="data-items">
                                                <span>
                                                    {{timeTitle(deliverable.all_completed)}}: {{runningTime(deliverable)}}
                                                </span>
                                            </div>

                                        </div>

                                        <div class="row listing-row">
                                            <div class="col-md-11 titles breakpoint__fix" :style="infoColStyle(deliverable)">

                                                <div :class="`dashboard-list-title`" v-if="deliverable.title.length < 45">
                                                    {{ deliverable.title }}
                                                </div>
                                                 <div :class="`dashboard-list-title`" v-else>
                                                    {{ deliverable.title }}
                                                </div>

                                                <div v-if="showDepartment(deliverable)">
                                                    <div  v-if="deliverable">
                                                        <div
                                                            class="department-title exclude-outside-click"
                                                            v-for="(department, index) in deliverable.departments"
                                                            :key="'deliverable-modal-department-'+department.id"
                                                        >
                                                            <span style="color: #2D3135" v-if="index > 0">&nbsp;&</span> {{ department.name }}
                                                        </div>
                                                    </div>
                                                </div>
                                                 <div v-if="_.filter(deliverable.customFields, {field_key: 'questions'}).length==0">
                                                    <b-carousel
                                                        id= "index"
                                                        no-animation
                                                        :interval="8000"
                                                        controls
                                                        indicators

                                                        img-blank


                                                        >
                                                        <!-- Slide with blank fluid image to maintain slide aspect ratio -->
                                                        <b-carousel-slide caption="" img-blank img-alt="Blank image">
                                                                <div > No questions have been entered. </div>
                                                        </b-carousel-slide>

                                                    </b-carousel>
                                                </div>
                                                <div v-for="(field,index) in _.filter(deliverable.customFields, {field_key: 'questions'})" :key="index">
                                                <b-carousel
                                                    id= "index"
                                                    no-animation
                                                    :interval="8000"
                                                    controls
                                                    indicators

                                                    img-blank

                                                    @sliding-start="onSlideStart"
                                                    @sliding-end="onSlideEnd"
                                                    >
                                                    <!-- Slide with blank fluid image to maintain slide aspect ratio -->
                                                    <b-carousel-slide caption="" img-blank img-alt="Blank image" v-for="n in setSlidingArray(field.value)" :key="n">
                                                            <div class="" v-html="strippedContent(field.value, n)"></div>
                                                    </b-carousel-slide>

                                                    </b-carousel>
<!-- <p>===================</p>
<div>{{setSlidingArray(field.value)}}</div>
<div v-html="strippedContentOrigin(field.value)"></div> -->
                                                </div>
                                            <div v-if="false" title="Delete" class="delete-bar">
                                            </div>
                                            </div>
                                            <div class="col-md-1 infos">
                                                <div class="d-flex flex-row">
                                                    <DeliverableStatusOverview :deliverable="deliverable"   v-if="!deliverable.all_completed" />
                                                </div>
                                            </div>
                                        </div>  <!-- -->
                                        <div class="bottom-row"  :style="bottomRowStyle(deliverable.tasks)">
                                        </div>
                                    </div>
                                </div>
                          </div>
                    </masonry>


 <!-- component end -->
    </div>
    </div>

</div>
</div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import EditModal from "../deliverables/EditModal";
import TaskFields from "../deliverables/TaskFields";
import TaskFieldLabels from "../deliverables/TaskFieldLabels";
import CreateContactModal from "../deliverables/CreateContactModal";
import UpdateContactModal from "../deliverables/EditContactModal";
import ViewTitleModal from "../common/ViewTitleModal";
import UpdateSpokespersonModal from "../deliverables/EditSpokespersonModal";
import CreateSpokespersonModal from "../deliverables/CreateSpokespersonModal";
import vueStarRate from "vue-js-star-rating";

import DuplicateMediaCallBtn from "../common/DuplicateMediaCallBtn";
import DashboardListStatusOverview from './DashboardListStatusOverview';
import DeliverableStatusOverview from '../deliverables/DeliverableStatusOverview';
// import DeliverablePriorityBadge from "../common/DeliverablePriorityBadge";

import UpdateWhoModal from "../deliverables/EditWhoModal";
import CreateWhoModal from "../deliverables/CreateWhoModal";
import Vue from "vue";

import DeliverableListTags from "../deliverables/DeliverableListTags";
import DeliverableProjects from "../deliverables/DeliverableProjects";
import DeliverableDepartments from "../deliverables/DeliverableDepartments";
import DeliverableListContacts from "../deliverables/DeliverableListContacts";
import DeliverableListCoordinators from "../deliverables/DeliverableListCoordinators";
import TaskCompletionGraph from "../deliverables/TaskCompletionGraph";
import CollapseTaskBtn from "../deliverables/CollapseTaskBtn";
import DeliverableTypeIcon from '../deliverables/DeliverableTypeIcon';
import DeliverableDatesRibbon from "../deliverables/DeliverableDatesRibbon";
import DeliverableCustomFields from '../common/DeliverableCustomField';

import CustomFields from './CustomFields';

import HeaderIcon from '../deliverables/HeaderIcon';
import toast from '../../toast';

// import { Swiper, SwiperSlide } from 'swiper/vue';
// import 'swiper/swiper-bundle.min.css'
// import 'swiper/swiper.min.css'

// import MediaCallsList from "./MediaCallsList"; //NumberStat

import VueMasonry from 'vue-masonry-css'
Vue.use(VueMasonry);

import $ from "jquery";

import {Swiper} from 'vue2-swiper'

export default {
	props: ["myWeek", "expandAll"],
	data() {
		return {
			animateDistance:0,
			quarterHeight:250,
			halfHeight:500,
			fullHeight:1000,
			dashboardDeliverables:[],
			newMediaCallCount:0,
			spliceAmount:0,
			loading:false,
			swiperCSSOpacity:1,
			swiperCSSTop:0,
			startSlide:0,
			maxDays:14,
			addHoursToUTC:6,
			swiperCSS:"",
            filterQuery: {
                sort: "",
                query: "",
                filterByDate: false,
                filterByTaskDate: false,
                dateRange: {
                startDate: new Date(),
                endDate: new Date(),
                },
                taskDateRange: {
                startDate: new Date(),
                endDate: new Date(),
                },
                dateCompletedRange: {
                startDate: new Date(),
                endDate: new Date(),
                },
                filterByDateCreated : true,
                dateCreatedRange : {"startDate":"2022-08-11T05:00:00.942Z","endDate":"2022-08-12T05:00:00.942Z"},
                status: [{name: "Awaiting Approval", color: "#FFA500"},{name: "In Progress", color: "#8A2BE2"},{name: "Pending Completion", color: "#483D8B"} ],
                outlet: [],
                deliverableType: [],
                tag: [],
                department: [],
                coordinator: [],
                project: [],
                noDepartment: "not_accepted",
                noOutlet: "not_accepted",
                pageCount:100,
                weekFilterOptions: {
                    overdue: false,
                    today: false,
                    thisWeek: false,
                    nextWeek: false,
                    upcoming: false,
                    noDeadline: false,
                },
                dashboardType: 'list',
            },
            swiperKey:1,
            countdownKey:1,
            lastUpdated: new Date(),
            isOnLine:navigator.onLine,
            stringQuestion: null,
            timer: null,
            setTimerInterval: 10000,
            slide:0,
            sliding: null,
            slidingArray: [[]],
            questionSpliceCount:0,
            questionShowOrder:0,

            maxCount:0,
            slideCount:0,
            totalPage:0,
            listCountOfPage:0,
            PageCountOfSwiper:2,
            isLoaded:false,
            totalCount:0,
            swiperAutoplayTime:0,

            progressBarValue: 0,
            progressBarMaxValue: 50,
            swiperCurrentPageNumber:0,
            showCountdownBar:false,
		}
	},
	created() {
		//this.fetchDeliverables();
		// this.fetchContacts();
		// this.fetchDepartments();
		// this.fetchActiveDepartments();
		// this.fetchProjects();
		// this.fetchViews();
		// this.fetchSubjects();
		// this.fetchTags();
		// this.fetchUsers();
		// this.fetchActiveUsers();
		// this.fetchGeoData();
		// this.fetchAllCustomFields();
	},
	components: {
		EditModal,
		TaskFields,
		TaskFieldLabels,
		DeliverableListContacts,
		CreateContactModal,
		UpdateContactModal,
		UpdateSpokespersonModal,
		CreateSpokespersonModal,
		UpdateWhoModal,
		CreateWhoModal,
		DeliverableListTags,
		DeliverableListCoordinators,
		TaskCompletionGraph,
		CollapseTaskBtn,
		DuplicateMediaCallBtn,
		DeliverableDatesRibbon,
		DeliverableDepartments,
		ViewTitleModal,
		vueStarRate,
		DeliverableProjects,
		DeliverableTypeIcon,
		DashboardListStatusOverview,
        DeliverableStatusOverview,
		DeliverableCustomFields,
        CustomFields,
		HeaderIcon,
        Swiper,
        // MediaCallsList

		// DeliverablePriorityBadge
	},
    filters: {

    },
	computed: {
		...mapGetters([
			"allDeliverables",
			"allDeliverablesPaginationData",
			"userDeliverablesPaginationData",
			"allTags",
			"allContacts",
			"deliverableDetail",
			"allDepartments",
			"allSubjects",
			"userDeliverables",
			"unGroupedUserDeliverables",
			"deliverableFilter",
      		"myWeekDeliverableFilter",
			"outletCount",
			"userAbilities",
      		"userViews",
			"deliverableTypes",
			"userManageProjects",
			"deliverableCount",
		]),
		...mapState({
			editDeliverableModal: state => state.deliverables.editDeliverableModal,
			addContactModal: state => state.deliverables.addContactModal,
			editContactModal: state => state.deliverables.editContactModal,
			editSpokespersonModal: state => state.deliverables.editSpokespersonModal,
			editWhoModal: state => state.deliverables.editWhoModal,
		}),
		countdownBarClasses() {

			return "countdown-bar";

		},


		deliverableListIcon() {
			if(this.deliverableFilter.deliverableType && typeof(this.deliverableFilter.deliverableType[0]) == 'undefined') {
				if(typeof this.deliverableFilter.deliverableType.id != 'undefined' && this.deliverableFilter.deliverableType.id != 'all') {
					return this.deliverableFilter.deliverableType.id.replaceAll('_', '-');
				} else {
					return 'media-call';
				}
			} else {
				return 'media-call';
			}
		},
		deliverablesArray(n) {
			return this.dashboardDeliverables;
			/*
				this.spliceAmount++;
				if (this.spliceAmount > this.dashboardDeliverables.length ) {
					this.spliceAmount = 1;
				}
				return this.dashboardDeliverables.splice(0,this.spliceAmount);
			*/
		},
		_() {
			return _;
		},

		userViewsDeliverable() {
			return _.filter(this.userViews, {view_type: "deliverable"});
		},

        swiperAutoplay(){
            if (this.swiperAutoplayTime ==0){
                this.swiperAutoplayTime = 50000;
            }
            // this.$refs.swiper.autoplay = this.swiperAutoplayTime;
        //   console.log("--------------------------> this.allDeliverables4", this.allDeliverables.length)
            return  this.swiperAutoplayTime; //this.$refs.swiper.autoplay;
        }
 	},
	methods: {
		...mapActions([
			"fetchDeliverables",
			"createTag",
			"fetchUsers",
			"fetchActiveUsers",
			"fetchContacts",
			"updateFieldValue",
			"fetchDepartments",
			"fetchActiveDepartments",
			"fetchSubjects",
			"fetchTags",
			"fetchGeoData",
			"fetchAllCustomFields",
			"filterDeliverables",
			'fetchViews',
			'fetchProjects',
			'getDeliverableTypes',
			'fetchUserManageProjects',
			"fetchDeliverableCount",
            "fetchPublicDeliverables",
		]),
		...mapMutations([
			"setDataLoading",
		]),



        setSlidingArray: function(string){
            if ( string != null){
                let startNo = 330;
                let TstringQuestion = string.replaceAll("<p>&nbsp;</p>", "").replaceAll("&nbsp;", "").replaceAll(/<\/?span[^>]*>/g,"")
                TstringQuestion = TstringQuestion.replaceAll('<br/>I', 'I');
                TstringQuestion = TstringQuestion.replaceAll('<br/><br/>', '<br/>');
                TstringQuestion = TstringQuestion.replaceAll('<br/>', '_.');
                let count = Math.ceil(TstringQuestion.length / startNo);
                // this.questionSpliceCount = count;

                if ( count > this.maxCount){
                    this.maxCount = count;
                }
                // console.log("slidingArgy count ", count);
                // console.log("slidingArgy count ",  this.maxCount);

                return count;
            }
            // this.slidingArray.puth("a")
        },
        strippedContent: function(string, step) {
            if ( string != null){
                let startNo = 200;
                 startNo = 100000;
                let TstringQuestion = string.replaceAll("<p>&nbsp;</p>", "").replaceAll("&nbsp;", "").replaceAll(/<\/?span[^>]*>/g,"")
                TstringQuestion = TstringQuestion.replaceAll('<br/>I', 'I');
                TstringQuestion = TstringQuestion.replaceAll('<br/><br/>', '<br/>');

                TstringQuestion = TstringQuestion.replaceAll('<br/>', '_.');
                let count = Math.ceil(TstringQuestion.length / startNo);

                // console.log("=========================== step", step);
                // console.log("===========================  this.questionSpliceCount",  this.questionSpliceCount);
                // console.log("=========================== count", count);



                if( step == 1){
                    var r = TstringQuestion.substr(startNo*step, 50).indexOf(" ");
                    TstringQuestion =  TstringQuestion.slice(0,startNo*step+r);
                }else{
                    var r = TstringQuestion.substr(startNo*(step-1), 50).indexOf(" ");
                    var r2 = TstringQuestion.substr(startNo*step, 50).indexOf(" ");
                    TstringQuestion =  TstringQuestion.slice(startNo*(step-1)+r,startNo*step+r2);

                }
                if ( count > step){
                    TstringQuestion = TstringQuestion +  " <span class='question-next'>...</span>";
                }

                    // console.log("=============================>Parsing Before TstringQuestion", TstringQuestion);
                    // // TstringQuestion = TstringQuestion.replaceAll('/>', '');
                    // // TstringQuestion = TstringQuestion.replaceAll('<', '');
                    TstringQuestion = TstringQuestion.replaceAll('_.', '<br/>');
                    // console.log("=============================>Parsing After TstringQuestion", TstringQuestion);

                // console.log("=============================>r", r);
                // console.log("=============================>TstringQuestion", TstringQuestion);

                // let TstringQuestion = string.replace(/<\/?[^>]+>/ig, " ");

                return TstringQuestion;
            }
        },

        dashboardListingClass() {
        	let className = "dashboard-list-listing ";
        	let maxHeightClass = "";
        	/*
        	1 - 4 =  full size
        	5 - 8 =  half height
        	9+ = quarter height (normal size)
        	*/
        	maxHeightClass = " quarter-height";

        	if (this.deliverablesArray.length <= 4) {
        		maxHeightClass = " full-height";
        	}
        	if (this.deliverablesArray.length > 4 && this.deliverablesArray.length <= 8) {
        		maxHeightClass = " half-height";
        	}

        	return className + maxHeightClass;
        },

        onSlideStart(slide) {
            this.sliding = true
        },
        onSlideEnd(slide) {
            this.sliding = false
        },
        parseJson(data) {
            try {
                return JSON.parse(data);
            } catch (e) {
                return data;
            }
        },
        taskColor(task) {
            let status = _.filter(task.taskFields, {field_key: 'status'});
            //   console.log("onChangeTitleColor overview.",status)
            // this.$emit("onChangeTitleColor",status);
            if(status.length) {
                return this.parseJson((status)[0].value).color;
            }
            return '';
        },

        bottomRowStyle(tasks) {
        	if (tasks) {
        		return "border-bottom:1px solid #eee; border-left:1px solid #eee;  border-right:8px solid "+ this.taskColor(tasks[tasks.length - 1])+"";
        	}
        	return null;
        },
        timeTitle(all_completed){
            if(all_completed){
                return "ELAPSED TIME";
            }else{
                return "RUNNING TIME";
            }
        },
        runningTime(deliverable){

             let returnRunningTime = "";
             let fromDate = Vue.moment().format("YYYY-MM-DD HH:mm")

            if (deliverable.all_completed){
                 fromDate = deliverable.completed_at;
            }
                let months = this.$moment.utc( this.$moment(fromDate, 'YYYY-MM-DD HH:mm').diff(this.$moment(deliverable.created_at, 'YYYY-MM-DD HH:mm').subtract(5, 'hours'))).format("M");
                let dd = this.$moment.utc( this.$moment(fromDate, 'YYYY-MM-DD HH:mm').diff(this.$moment(deliverable.created_at, 'YYYY-MM-DD HH:mm').subtract(5, 'hours'))).format("D");
                let hh = this.$moment.utc( this.$moment(fromDate, 'YYYY-MM-DD HH:mm').diff(this.$moment(deliverable.created_at, 'YYYY-MM-DD HH:mm').subtract(5, 'hours'))).format("H");
                let mm = this.$moment.utc( this.$moment(fromDate, 'YYYY-MM-DD HH:mm').diff(this.$moment(deliverable.created_at, 'YYYY-MM-DD HH:mm').subtract(5, 'hours'))).format("m");

                const dateC = this.$moment.utc( this.$moment(deliverable.created_at, 'YYYY-MM-DD HH:mm').subtract(5, 'hours'));

                if (months > 0){
                     months = months -1;
                    if ( months > 0 ) {
                        if ( months ==1){
                            returnRunningTime = returnRunningTime + " "+months + "  month";
                        }else{
                            returnRunningTime = returnRunningTime + " "+months + "  months";
                        }
                    }
                }
                if ( dd > 0){
                    dd = dd -1;
                    if ( dd > 0) {
                        if ( dd == 1){
                            returnRunningTime = returnRunningTime + " "+dd + " day";
                        }else{
                            returnRunningTime = returnRunningTime + " "+dd + " days";
                        }
                    }
                }
                if ( hh > 0 ){
                    returnRunningTime = returnRunningTime + " "+hh+"h";
                }
                if ( mm > 0){
                    returnRunningTime = returnRunningTime + " "+mm+"min";
                }


                if (returnRunningTime == "") {
                	let ss = this.$moment.utc( this.$moment(fromDate, 'YYYY-MM-DD HH:mm:ss').diff(this.$moment(deliverable.created_at, 'YYYY-MM-DD HH:mm:ss').subtract(5, 'hours'))).format("s");
                	if (ss > 0) {
                		if (ss == 1) {
                			returnRunningTime = returnRunningTime + " "+ss+" second";
                		} else {
	                    	returnRunningTime = returnRunningTime + " "+ss+" seconds";
	                    }
                	}
                }




                return returnRunningTime;
        },

          getBgColor(tasks){
           let i = 0;
           let color = "#778899";
				if (tasks) {
	            tasks.forEach(x => {
						const dueDateField = x.taskFields.filter(y => y.field_key == 'status');
	                    i++;
	                    if (i==1) {
	                       color = this.parseJson( dueDateField[0].value).color;
	                    }
			   });
	        }

            return color;
        },
        sliderMove(offset){
        // console.log('slider-move: ' + offset)

        },

        getTitleBgColor(tasks){
        //    console.log("===================tasks.taskFields", tasks)

           let i = 0;
           let color = "#778899";
           let statusCountAwaiting = 0;
           let statusCountPending = 0;
           let statusCountProgress = 0;
           if (tasks) {
	            tasks.forEach(x => {
						const dueDateField = x.taskFields.filter(y => y.field_key == 'status');
	                    // console.log("dueDateField.value", dueDateField[0].value)
	                    i++;
	                    // console.log("i",i )
	                    if (i==1) {
	                       color = this.parseJson( dueDateField[0].value).color;
	                    }
	                    if ( this.parseJson(dueDateField[0].value).name == "Awaiting Approval"){
	                            statusCountAwaiting = statusCountAwaiting+1;
	                    }
	                    if ( this.parseJson(dueDateField[0].value).name == "Pending Completion"){
	                            statusCountPending = statusCountPending+1;
	                    }
	                    if ( this.parseJson(dueDateField[0].value).name == "In Progress"){
	                            statusCountProgress = statusCountProgress+1;
	                    }

			   });
	        }

           if ( statusCountProgress > 0){
                color = "#8A2BE2";
           }else{
                if ( statusCountPending > 0 && statusCountAwaiting > 0){
                    color = "#8A2BE2";
                }else{
                    if ( statusCountPending > 0){
                        color = "#483D8B";
                    }else if  ( statusCountAwaiting > 0){
                        color = "#FFA500";
                    }else{
                        color = "#8A2BE2";
                    }
                }

           }
            return color;
        },


    slideChangeStart(number){
             // console.log("reload slideChangeStart number...........................", number)
             //  console.log("reload slideChangeStart totalCount...........................", this.totalCount)
            // this.swiperKey++;
    		this.countdownKey++;
            this.swiperCurrentPageNumber = number;
            this.progressBarValue = 0;
            this.showCountdownBar = true;
            clearInterval(this.timer);

            // reset the animation of the countdown bar.
            const elm = document.getElementById("countdownBar");
            if (elm) {
	            var newone = elm.cloneNode(true);
	            elm.parentNode.replaceChild(newone, elm);
	        }

            // this.timer = setInterval(this.setTimer, this.setTimerInterval);
            this.timer = setTimeout(this.setSwiperTimer, this.setTimerInterval);
            // console.log("reload slideChangeStart totalCount 2...........................", this.totalCount)
    },


    updateSwiperStyle() {
    	let css = "opacity:" + this.swiperCSSOpacity + ";";
    	// css += "top:" + this.swiperCSSTop + "px;";
    	this.swiperCSS = css;
    },

    swiperNext(){
			// console.log(this.getTranslateXY($(".swiper-wrapper").get(0)));
    		// this.animateAway();

    		// if (this.swiperCurrentPageNumber < this.totalPage - 1) {
    		// 	this.$refs.swiper.setPage(this.totalPage - 1,false);
    		// }
    	// console.log("swiperCurrentPageNumber:"+this.swiperCurrentPageNumber);
    	// console.log("totalPage:"+this.totalPage);

           if ( this.swiperCurrentPageNumber < this.totalPage && this.totalPage > 1 ){
	           	this.showCountdownBar = true;
                this.$refs.swiper.next();
                // if (this.swiperCurrentPageNumber ==  this.totalPage - 1) {
	            //     this.fetchPublicDeliverables(1);
	            // }
           }else{
            	this.animateAway();

	           	this.showCountdownBar = false;
	           	this.$nextTick(() => {
		           	this.showCountdownBar = false;
	           	});

               let that = this;
               this.loading = true;
               setTimeout(function(){
               		// that.swiperCSSTop = 1100;
               		// that.updateSwiperStyle();
                    // that.swiperCurrentPageNumber =1;
                    // that.$refs.swiper.setPage(1,false)
                    that.reload();
                }, 0);


           }
    },
    setTimer(){
    	this.swiperNext();
        if(this.progressBarValue < this.progressBarMaxValue){
            this.progressBarValue = this.progressBarValue + 1;
        }else{
            this.swiperNext();
        }
    },

    setSwiperTimer(){
    	this.swiperNext();
    },

		infoColStyle(deliverable) {
			if (deliverable.title == "Media call") {
				// console.log(deliverable.title);
				return " ";
			}
			// Unused for now
			if (deliverable.deliverable_template_id == 8) {
				// return 'min-height:96px';
				return '';
			} else {
				return null;
			}
		},
		showDepartment(deliverable) {
			// return deliverable.deliverable_template_id != 8;
			return deliverable.deliverable_template_id == 1;
		},

		getTranslateXY(element) {
			console.log(element);
		    // const style = window.getComputedStyle(element)
		    const matrix = $(".swiper-wrapper").css("transform");
		    return {
		        translateX: matrix.m41,
		        translateY: matrix.m42
		    }
		},
		animateAway() {
			let y = 0;
			y = this.quarterHeight;
			if (this.deliverablesArray.length <= 4) {
				y = this.fullHeight;
			}
			if (this.deliverablesArray.length > 4 && this.deliverablesArray.length <= 8) {
				y = this.halfHeight;
			}
			this.animateDistance = y;

			// Get the transformation matrix and slide the swiper wrapper up one more position.
			var object = $(".swiper-wrapper");
			var transMatrix = object.css("-webkit-transform") ||
			                  object.css("-moz-transform") ||
			                  object.css("-ms-transform") ||
			                  object.css("-o-transform") ||
			                  object.css("transform");
			if (transMatrix) {
				var values = transMatrix.match(/[\-\d\.]+(?=[,)])/g);
				let distance = parseInt(values[5]) - this.animateDistance;
				$(".swiper-wrapper").css("transform", "translate3d(0px, " + distance + "px, 0px)");
				$(".swiper-wrapper").css("transition-duration", "1000ms");
			}
		},
		animateBack() {
			// Don't need to animate back...
		},

    async reload(){
    	let that = this;
    	this.loading = true;
		this.showCountdownBar = false;
		that.countdownKey++;
		if (this.countdownKey > 30) {
			this.countdownKey = 1;
		}
    	let fromDate = this.$moment.utc().subtract(this.maxDays, 'days');
    	let endDate = this.$moment.utc().add(this.addHoursToUTC, 'hours');
    	this.filterQuery.dateCreatedRange.startDate = fromDate.format();
    	this.filterQuery.dateCreatedRange.endDate = endDate.format();
         this.$store.commit("setDashboardMediaCallsFilter", this.filterQuery);
        await this.fetchPublicDeliverables(1);

        this.$nextTick(() => {this.newMediaCallCount = 0;
        	this.newMediaCallCount = 0;
        });


        this.swiperCSSOpacity = 0;
        this.updateSwiperStyle();
        /*
        this.loading = false;
        this.dashboardDeliverables = this.allDeliverables;

        // this.totalCount = this.allDeliverablesPaginationData.total;
        // this.totalPage= Math.ceil(this.allDeliverablesPaginationData.total/ this.PageCountOfSwiper);
        console.log(this.deliverablesArray.length);
        this.totalCount = this.deliverablesArray.length;
        this.totalPage= Math.ceil(this.totalCount/ this.PageCountOfSwiper);

        this.swiperKey++;
		*/



        // if ( this.totalCount > this.listCountOfPage ) {
        //     /*
        //     if ( this.timer == null){
        //         this.slideChangeStart(this.startSlide);
        //     }
        //     */
        //     clearInterval(this.timer);
        //     this.slideChangeStart(this.startSlide);
        // }else{
        //      if ( this.timer != null){
        //         clearInterval(this.timer);
        //      }
        // }

        setTimeout(function() {
	        if ( that.timer != null){
	           clearInterval(that.timer);
	        }

            if (JSON.stringify(that.dashboardDeliverables) === JSON.stringify(that.allDeliverables)) {
            	// we're all good.
            	// console.log("same data");
            } else {
            	// console.log("different data");
    	        // that.dashboardDeliverables = that.allDeliverables;
    	        that.dashboardDeliverables = _.cloneDeep(that.allDeliverables)
    	    }

	        // that.totalCount = that.allDeliverablesPaginationData.total;
	        // that.totalPage= Math.ceil(that.allDeliverablesPaginationData.total/ that.PageCountOfSwiper);
	        that.totalCount = that.deliverablesArray.length;
	        that.totalPage= Math.ceil(that.totalCount/ that.PageCountOfSwiper);
	        that.swiperKey++;
	        if (that.swiperKey > 30) {
	        	that.swiperKey = 1;
	        }
       		that.animateBack();
	    },500);

        setTimeout(function() {
        	that.swiperCSSOpacity = 1;
        	that.updateSwiperStyle();
			that.slideChangeStart(that.startSlide);
			that.loading = false;
	    },1000);


        // setTimeout(function() {
		// 	that.slideChangeStart(that.startSlide);
	    // },1500);


        this.lastUpdated = new Date();
        this.$emit("lastUpdated", this.lastUpdated);

         },

	},


	async mounted() {
		let fromDate = this.$moment.utc().subtract(this.maxDays, 'days');
		let endDate = this.$moment.utc().add(this.addHoursToUTC, 'hours');
		this.filterQuery.dateCreatedRange.startDate = fromDate.format();
		this.filterQuery.dateCreatedRange.endDate = endDate.format();


        this.$store.commit("setDashboardMediaCallsFilter", this.filterQuery);
        await this.fetchPublicDeliverables(1);
        // this.totalCount = this.allDeliverablesPaginationData.total;
        // this.totalPage= Math.ceil(this.allDeliverablesPaginationData.total/ this.PageCountOfSwiper);

        this.totalCount = this.deliverablesArray.length;
        this.totalPage= Math.ceil(this.totalCount/ this.PageCountOfSwiper);


       this.lastUpdated = new Date();
        this.$emit("lastUpdated", this.lastUpdated);

        this.$nextTick(() => {
            if ( this.timer == null){
                //  console.log("slidingArgy First mounted after  second", this.maxCount * 3000);
            }
                // this.fadeTest();

            this.slideChangeStart(this.startSlide);

	        // if ( this.totalCount > this.listCountOfPage ) {
	        //     this.slideChangeStart(this.startSlide);
	        // }

       })
        this.isLoaded = true;


		Echo.channel('deliverable').listen('DeliverableCreated', (e) => {
            this.newMediaCallCount++;
		})
        .error((error) => {
                console.error("Error", error);
        });



        /*
		Echo.channel('deliverable').listen('DeliverableUpdated', (e) => {
			console.log("DeliverableUpdated event");
				let x = 0;
                let isChecked =false;
                console.log("channel allDeliverables length",  this.allDeliverables.length)
                console.log("channel deliverable..this.totalCount", this.totalCount)
				for (x = 0; x < this.allDeliverables.length; x++) {
					if (this.allDeliverables[x].id == e.deliverable.deliverableId) {
             			this.$store.commit("setDeliverable", e.deliverable);
						this.$store.commit("setDeliverableDetail", e.deliverable);
                        isChecked = true;
                        console.log("channel", isChecked)

					}
				}
                if (!isChecked){
                	this.newMediaCallCount++;
                //   this.fetchPublicDeliverables(1);
                  console.log("channel isChecked..", isChecked)
                //   this.reload();
                if ( this.totalPage <= 6 ){
                        // this.reload();
                }
               }
               // this.reload();
                this.lastUpdated = new Date();
                this.$emit("lastUpdated", this.lastUpdated);
		})
        .error((error) => {
                console.error("Error", error);
        });
        */

        /*
		Echo.channel('task').listen('TaskUpdated', (e) => {
			this.newMediaCallCount++;
               console.log("channel TaskUpdated..this.totalCount", this.totalCount)
            if (e.task.length == 0){
                  console.log("channel TaskUpdated e.task.length == 0")

            }else{
                console.log("channel TaskUpdated e.task.length > 0")
               let x = 0;
				let xx = 0;
				for (x = 0; x < this.allDeliverables.length; x++) {
					if (this.allDeliverables[x].id == e.deliverableId) {
						// ok, lets update the task now for that deliverable..
						for (xx = 0; xx < this.allDeliverables[x].tasks.length; xx++) {
							if (this.allDeliverables[x].tasks[xx].taskId == e.task.taskId) {
								    this.$store.commit("setTask", {task:e.task, deliverableId: e.deliverableId});
								}
						}
					}
				}

            }

            // this.reload();
            this.lastUpdated = new Date();
            this.$emit("lastUpdated", this.lastUpdated);
			// if (userId != e.user.id) {
			// }
		});
		*/
	},

};
</script>
<style>

#swiper__media-calls {
	transition: opacity 1s;
	opacity:1;
}

/* transform: translate3d(0px, -972px, 0px); transition-duration: 0ms; */

.newMediaCallCount {
}

</style>
